<template>
  <component
    :is="href ? 'a' : 'button'"
    :class="buttonClasses"
    v-bind="{
      ...(href && { href }),
      ...(target && {
        rel: 'noreferrer noopener',
        target,
      }),
    }"
    :type="!href && type"
    :disabled="disabled"
    v-on="listeners"
  >
    <template v-if="isSpinnerActive">
      <Spinner :class="spinnerClasses" />
    </template>

    <slot />
  </component>
</template>

<script>
import isEmpty from 'lodash/isEmpty'

import Spinner from './Spinner'

export default {
  name: 'SanitasButton',

  components: {
    Spinner,
  },

  props: {
    type: {
      type: String,
      default: 'button',
    },

    primary: Boolean,
    secondary: Boolean,
    link: Boolean,
    disabled: Boolean,
    fullWidthInXs: Boolean,
    isSpinnerActive: Boolean,
    isNegative: Boolean,

    href: {
      type: String,
      default: undefined,
    },

    target: {
      type: String,
      default: undefined,
    },
  },

  computed: {
    buttonClasses() {
      return {
        'sanitas-button': true,
        'is-primary': this.primary,
        'is-secondary': !this.primary && this.secondary,
        'is-link': !this.primary && !this.secondary && this.link,
        'is-disabled': this.disabled,
        'is-fullwidth-xs': this.fullWidthInXs,
        'is-spinning': this.isSpinnerActive,
        'is-negative': this.isNegative,
        'has-text': !isEmpty(this.$slots),
      }
    },
    listeners() {
      return { click: this.handleTap }
    },
    spinnerClasses() {
      let classes = ['spinner']
      if (this.primary) {
        classes.push('theme--white')
      }
      if (this.secondary) {
        classes.push('theme--original-green')
      }
      return classes
    },
  },

  methods: {
    handleTap(event) {
      if (this.href && this.disabled) {
        event.preventDefault()
        return
      }
      this.$emit('sanitas_button_tap', event) /* deprecated */
      this.$emit('click', event)
    },
  },
}
</script>

<style>
/* is defined in global scoped aem/sanitas-button.pcss */
</style>
